import { queries } from "../../../shared/queries";
import { useIsMobile } from "../../hooks/useIsMobile";
import { useQuery } from "@rocicorp/zero/react";
import { navigate, routes } from "../../lib/urls";
import { Icon } from "../Icon";
import { Tooltip } from "../Tooltip";
import { ChatpadButton } from "./ChatpadButton";

export function PersonalChatVolumesButton({
  disabled,
}: {
  disabled?: boolean;
}) {
  const isMobile = useIsMobile();
  const [volumes] = useQuery(queries.personalVolumes());
  const [personalSpace] = useQuery(queries.personalSpace());

  if (volumes.length === 0 || !personalSpace) return null;

  return (
    <Tooltip content="Browse storage" side={isMobile ? "right" : "left"}>
      <ChatpadButton
        aria-label="Browse storage"
        disabled={disabled}
        onPress={() =>
          navigate(routes.modal.storage, {
            spaceId: personalSpace.id,
            section: "chats",
          })
        }
      >
        <Icon name="box" size={12} />
      </ChatpadButton>
    </Tooltip>
  );
}
